import React from 'react';
import LocationTemplate from './LocationTemplate';

const BelhavenPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Belhaven"
      stateName="North Carolina"
      countyName="Beaufort"
      zipCodes={["27810"]}
      latitude={35.5387}
      longitude={-76.6196}
      population={1513}
      historicalFact="Incorporated in 1899, name means 'beautiful harbor' in Scottish; known for its waterfront location."
      nearbyTowns={[
        "Washington, NC",
        "Plymouth, NC",
        "Pantego, NC",
        "Aurora, NC",
        "Swan Quarter, NC",
        "Columbia, NC",
        "Engelhard, NC",
        "New Bern, NC"
      ]}
    />
  );
};

export default BelhavenPage;